import PageHeader from "@/components/feature/PageHeader";
import ContactForm from "./components/ContactForm";
import useDocumentTitle from "@/hooks/useDocumentTitle";

const CONTACT_INFO = [
  {
    icon: "ri-mail-line",
    label: "合作邮箱",
    value: "contact@heipilamei-films.example.com",
    tone: "primary",
  },
  {
    icon: "ri-phone-line",
    label: "联系电话",
    value: "010-8888 6666（工作日 10:00 - 18:00）",
    tone: "accent",
  },
  {
    icon: "ri-map-pin-line",
    label: "办公地址",
    value: "北京市朝阳区影都创意园区 A 座 1206",
    tone: "secondary",
  },
];

const SOCIAL = [
  { icon: "ri-weibo-fill", label: "微博", handle: "@黑皮辣妹影视频道" },
  { icon: "ri-wechat-fill", label: "微信公众号", handle: "黑皮辣妹影视频道" },
  { icon: "ri-bilibili-fill", label: "哔哩哔哩", handle: "黑皮辣妹影视" },
];

export default function ContactPage() {
  useDocumentTitle(
    "联系我们 - 黑皮辣妹",
    "联系黑皮辣妹影视资讯与剧情介绍频道，投稿、合作与内容反馈请通过联系表单或邮箱与我们取得联系。",
  );

  return (
    <div className="hp-fade-up">
      <PageHeader
        title="联系我们"
        description="无论是内容投稿、商务合作还是使用反馈，都欢迎随时联系我们，我们会尽快回复你的每一条留言。"
        breadcrumb={[{ label: "联系我们" }]}
        eyebrow="Contact"
      />

      <section className="w-full px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
          <div className="lg:col-span-2">
            <ContactForm />
          </div>

          <aside className="space-y-6">
            <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
              <div className="px-4 py-3 border-b border-background-200 bg-background-100">
                <h3 className="font-heading font-bold text-foreground-950 flex items-center gap-2">
                  <i className="ri-contacts-book-2-line text-secondary-500" />
                  联系方式
                </h3>
              </div>
              <ul className="divide-y divide-background-200">
                {CONTACT_INFO.map((info) => (
                  <li key={info.label} className="flex items-start gap-3 p-4">
                    <span
                      className={`w-10 h-10 shrink-0 flex items-center justify-center rounded-md ${
                        info.tone === "primary"
                          ? "bg-primary-100 text-primary-600"
                          : info.tone === "accent"
                            ? "bg-accent-100 text-accent-700"
                            : "bg-secondary-100 text-secondary-700"
                      }`}
                    >
                      <i className={`${info.icon} text-lg`} />
                    </span>
                    <span className="min-w-0">
                      <span className="block text-xs text-foreground-500">{info.label}</span>
                      <span className="block text-sm text-foreground-900 mt-0.5 break-all">
                        {info.value}
                      </span>
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
              <div className="px-4 py-3 border-b border-background-200 bg-background-100">
                <h3 className="font-heading font-bold text-foreground-950 flex items-center gap-2">
                  <i className="ri-share-circle-line text-secondary-500" />
                  关注我们
                </h3>
              </div>
              <ul className="p-4 space-y-2">
                {SOCIAL.map((s) => (
                  <li key={s.label}>
                    <a
                      href="#"
                      className="flex items-center gap-3 rounded-md bg-secondary-50 border border-secondary-200 px-3.5 py-2.5 hover:border-primary-300 transition-colors"
                    >
                      <span className="w-8 h-8 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                        <i className={s.icon} />
                      </span>
                      <span className="min-w-0">
                        <span className="block text-sm text-foreground-900">{s.label}</span>
                        <span className="block text-xs text-foreground-500">{s.handle}</span>
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </aside>
        </div>

        <div className="mt-8 rounded-lg overflow-hidden border border-background-200 bg-background-50">
          <iframe
            title="黑皮辣妹影视频道办公位置地图"
            src="https://www.google.com/maps?q=Beijing%20Chaoyang&output=embed"
            className="w-full h-[320px] md:h-[380px] border-0"
            loading="lazy"
          />
        </div>
      </section>
    </div>
  );
}